import GlobalSearchList from './GlobalSearch.vue';

export default GlobalSearchList;



// WEBPACK FOOTER //
// ./src/pages/global-search/index.ts